import React from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'react-bootstrap';
import Accordion from 'components/Accordion';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import { useClosure } from 'utils/hooks';
import useClearSelection from 'hooks/Meteorology/Weather/Comparator/useClearSelection';
import useSavePreference from 'hooks/Meteorology/Weather/Comparator/useSavePreference';
import Button from 'components/DesignSystem/Button';
import {
  selectMWComparatorControlPanelTriggerFetch,
} from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import FormModal from 'components/PreferenceModals/FormModal';
import Preferences from './Preferences';
import Variable from './Variable';
import Area from './Area';
import Model from './Model';
import './index.scss';

export default function ComparatorControlPanel() {
  const clearSelection = useClearSelection();
  const triggerFetch = useSelector(selectMWComparatorControlPanelTriggerFetch);
  const {
    showConfirmationModal,
    setShowConfirmationModal,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    showFormModal,
    setShowFormModal,
    valid,
    isLoading,
    onNameChange,
    handleSubmit,
  } = useSavePreference();

  return (
    <div>
      <ConfirmationModal
        open={showConfirmationModal}
        closing={useClosure(setShowConfirmationModal, false)}
      />
      <ErrorModal
        open={showErrorModal}
        closing={useClosure(setShowErrorModal, false)}
        message={errorMessage}
      />
      <FormModal
        show={showFormModal}
        onHide={useClosure(setShowFormModal, false)}
        valid={valid}
        isLoading={isLoading}
        onNameChange={onNameChange}
        handleSubmit={handleSubmit}
      />
      <Accordion defaultActiveKey="0">
        <Preferences />
        <Variable />
        <Area />
      </Accordion>
      <Model modelIndex={0} />
      <Model modelIndex={1} />
      <Row className="pt-5">
        <Button
          id="seasonal-comparator-request-button"
          type="primary"
          onClick={triggerFetch}
          disabled={triggerFetch === undefined}
        >
          Realizar Consulta
        </Button>
      </Row>
      <Row className="pt-1">
        <Button
          type="primary"
          onClick={useClosure(setShowFormModal, true)}
        >
          Salvar nova preferência
        </Button>
      </Row>
      <Row>
        <Button type="secondary" className="clear-filters mt-2" onClick={clearSelection}>
          Limpar filtros
        </Button>
      </Row>
    </div>
  );
}
